package com.vizio.redwolf.pay.client

import com.vizio.redwolf.pay.model.RewardsRequestInfo
import com.vizio.redwolf.utils.AppConfig
import com.vizio.redwolf.utils.CONTENT_TYPE_APP_JSON_UTF8
import com.vizio.redwolf.utils.ClientConfig
import com.vizio.redwolf.utils.HttpResult
import com.vizio.redwolf.utils.PayEnvironment
import com.vizio.redwolf.utils.SUBSCRIPTION_API_KEY
import com.vizio.redwolf.utils.applyAppConfig
import com.vizio.redwolf.utils.applyTimeout
import com.vizio.redwolf.utils.applyUserBearerToken
import com.vizio.redwolf.utils.buildHttpRequest
import com.vizio.redwolf.utils.safeHttpCall
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.headers
import io.ktor.client.request.parameter
import io.ktor.client.request.request
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpMethod
import io.ktor.http.URLProtocol
import io.ktor.http.path

class AccountRewardsHttpClient(private val environment: PayEnvironment, private val appConfig: AppConfig, private val clientConfig: ClientConfig) :
    AccountRewardsClient {

    private val httpClient: HttpClient = clientConfig.clientProvider.httpClient
    private val apiKey = environment.vizioApiSubscriptionKey
    private val payPath = environment.rewardsPath

    override suspend fun requestRewards(requestInfo: RewardsRequestInfo): HttpResult<HttpResponse> {
        val httpRequestBuilder = HttpRequestBuilder().apply {
            url {
                protocol = URLProtocol.HTTPS
                host = environment.payHost
                path("$payPath/rewards")
            }
            headers {
                append(HttpHeaders.ContentType, CONTENT_TYPE_APP_JSON_UTF8)
                append(SUBSCRIPTION_API_KEY, apiKey)
            }
            requestInfo.pageNumber?.let { parameter(PARAMETER_PAGE_NUMBER, requestInfo.pageNumber) }
            requestInfo.pageSize?.let { parameter(PARAMETER_PAGE_SIZE, requestInfo.pageSize) }
            applyAppConfig(appConfig)
            applyUserBearerToken(requestInfo.accessToken)
            applyTimeout(clientConfig.timeout)
            method = HttpMethod.Get
        }
        return safeHttpCall(httpRequestInfo = httpRequestBuilder.buildHttpRequest()) {
            httpClient.request(httpRequestBuilder)
        }
    }

    companion object {
        private const val PARAMETER_PAGE_NUMBER = "PageNumber"
        private const val PARAMETER_PAGE_SIZE = "PageSize"
    }
}